<template>
    <div class="login-page">
        <div class="login-card">
            <div class="login-card__header">
                <div class="login-card__logo">H</div>
                <div>
                    <h1>Hoo-ly</h1>
                </div>
            </div>
            <form
                class="login-form"
                @submit.prevent="login"
            >
                <div class="login-form__field">
                    <label
                        class="login-form__label"
                        for="email"
                    >{{ $filters.localize("login.login") }}</label>
                    <input
                        id="email"
                        v-model="userName"
                        type="text"
                        class="form-control login-form__control"
                        :placeholder="$filters.localize('login.login')"
                        autocomplete="username"
                        required
                    />
                </div>
                <div class="login-form__field">
                    <label
                        class="login-form__label"
                        for="password"
                    >{{ $filters.localize("login.password") }}</label>
                    <input
                        id="password"
                        v-model="userPassword"
                        type="password"
                        class="form-control login-form__control"
                        :placeholder="$filters.localize('login.password')"
                        autocomplete="current-password"
                        required
                    />
                </div>
                <button
                    class="btn login-form__submit"
                    type="submit"
                >
                    {{ $filters.localize("login.submit") }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VLogin',
    data() {
        return {
            userName: "",
            userPassword: ""
        };
    },
    methods: {
        login() {
            this.$store.dispatch("login", { UserName: this.userName, UserPassword: this.userPassword })
                .then(() => this.$router.push({ name: 'Contact' }))
                .catch(error => {
                    this.$toast.error(this.$filters.localize("login.invalid"));
                    console.log(error);
                });
        }
    },
}
</script>

<style scoped>
.login-page {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: #f4f7fb;
}

.login-card {
    width: min(100%, 420px);
    overflow: hidden;
    border: 1px solid #e4eaf2;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 18px 46px rgba(15, 38, 65, 0.14);
}

.login-card__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px;
    background: linear-gradient(135deg, #0f2641 0%, #173b5d 100%);
}

.login-card__logo {
    width: 42px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 42px;
    border-radius: 8px;
    color: #0f2641;
    background: #ffffff;
    font-size: 1.1rem;
    font-weight: 900;
    line-height: 1;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
}

.login-card__header h1 {
    margin: 0;
    color: #ffffff;
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: 0;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 20px;
    text-align: left;
}

.login-form__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.login-form__label {
    margin: 0;
    color: #526171;
    font-size: 0.76rem;
    font-weight: 800;
    text-transform: uppercase;
}

.login-form__control {
    min-height: 42px;
    border-color: #d9e2ec;
    border-radius: 8px;
    color: #243447;
    font-weight: 600;
}

.login-form__control:focus {
    border-color: #4f7fa7;
    box-shadow: 0 0 0 0.15rem rgba(79, 127, 167, 0.16);
}

.login-form__submit {
    min-height: 42px;
    margin-top: 2px;
    border: 1px solid #173b5d;
    border-radius: 8px;
    color: #ffffff;
    background: #173b5d;
    font-weight: 800;
}

.login-form__submit:hover,
.login-form__submit:focus {
    color: #ffffff;
    background: #0f2641;
}

@media (max-width: 420px) {
    .login-page {
        padding: 12px;
    }

    .login-card__header,
    .login-form {
        padding: 16px;
    }
}
</style>
